import styled from "styled-components";

export const PrivacyPolicyContainer = styled.div`
  background-color: #0aaabc;
  padding: 50px 0px;
  margin-top: -100px;
  display: flex;
  justify-content: center;
`;
export const TextContainer = styled.div`
  background-color: #fff;
  padding: 20px 5px;
  margin-top: 100px;
  border-radius: 20px;
  width: 90%;
`;
export const Header = styled.h1`
  color: #616060;
  margin-bottom: 30px;
  text-align: center;
`;
export const TextSection = styled.div`
  margin: 30px;
`;
export const TitleP = styled.h3`
  color: #616069;
  margin-bottom: 15px;
`;
export const Parahraph = styled.p``;

export const List = styled.ul`
  margin: 15px;
`;
